export const SITE_NAME = "UPS Technology";

export const SITE_SLOGAN = {
  cs: "Vaše jistota energie již 35 let",
  en: "Your energy security for 35 years",
  uk: "Ваша енергетична безпека протягом 35 років",
};
